import { ConnectionAgentApiEnum } from '~/src/models/enums/connection-agent-api.enum';

export interface ConnectionDataInterface {
    apiStand: ConnectionAgentApiEnum;
    applicationId: string;
    description: string;
    status: string;
    subscriptionId: string;
}

export class AgentsApiState {
    connectionList: Array<ConnectionDataInterface> = [];
}
